import React, { PropsWithChildren, ReactNode } from "react";

import { TemplateCategory } from "@/components/confluence/templates/template-categories-search";
import type {
    Template,
    TemplateCollection
} from "@/content/templates/template.types";
import { ConfluenceTemplatesUnifiedPageTemplate as ConfluenceTemplatesUnifiedPageTemplate } from "@/templates/software/confluence/templates/confluence-templates-page/src/confluence-templates-unified-page.template";

export type ConfluenceTemplatesPageTemplateProps = PropsWithChildren<{
    templates?: Template[];
    partnerTemplates?: Template[];
    collections?: TemplateCollection[];
    categories?: TemplateCategory[];
}>;

// Needed because scroll tracking doesn't work on context providers or on nested children
const CategoryViewScrollTrackingWrapper: React.FC<{ children: ReactNode }> = ({
    children
}) => <>{children}</>;
CategoryViewScrollTrackingWrapper.displayName = "TemplateCategoryView";

export const ConfluenceTemplatesPageTemplate = ({
    templates,
    partnerTemplates,
    collections,
    categories
}: ConfluenceTemplatesPageTemplateProps) => {
    return (
        <ConfluenceTemplatesUnifiedPageTemplate
            templates={templates}
            categories={categories}
            collections={collections}
            partnerTemplates={partnerTemplates}
        />
    );
};
